import { MenuItems as e } from "@headlessui/react";
import r from "styled-components";
import "../Theme/themes.es.js";
import "../../palettes-Bw24w7AF.js";
import { getZIndexes as d, getRadii as t, getEffects as i, getPaletteBorder as n, getPaletteBackground as l } from "../Theme/utils.es.js";
import "react";
import "../../jsx-runtime-C5mzlN2N.js";
import "../../CssBaseline-Bp4jdUgb.js";
const $ = r(e)`
  padding: 0;
  overflow: hidden;
  border-width: 1px;
  border-style: solid;
  box-sizing: border-box;
  flex-direction: column;
  outline: none;

  z-index: ${d("modal")};
  border-radius: ${t("md")};
  box-shadow: ${i("shadows.lg")};
  border-color: ${n("secondary")};
  background: ${l("primary.default")};
  display: ${(o) => o.$isHidden ? "none" : "flex"};
  width: ${(o) => o.$isFullWidth ? "100%" : "240px"};
`;
export {
  $ as Items
};
